class t {
  constructor(t2 = window) {
    this.target = t2;
  }
  emit(t2, e2) {
    this.target.dispatchEvent(new CustomEvent(String(t2), { detail: e2 }));
  }
  on(t2, e2) {
    const n2 = (t3) => {
      const n3 = t3;
      e2(n3.detail, n3);
    };
    return this.target.addEventListener(String(t2), n2), () => this.target.removeEventListener(String(t2), n2);
  }
}
const e = (e2) => new t(e2), n = e();
export {
  t as AppEventBus,
  n as appEventBus,
  e as createAppEventBus
};
//# sourceMappingURL=appEventBus.js.map
